import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Typography, Card,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  resultCard: {
    textAlign: 'center',
    margin: '1em',
    padding: '2em 0',
    minHeight: '10em',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: '140px',
  },
  gradeTitle: {
    margin: '0 1em',
    fontSize: '20px',
  },
  grade: {
    color: theme.palette.primary.main,
  },
}));

const GradeCard = ({ title, score, total }) => {
  const classes = useStyles();
  return (
    <Grid item md={4}>
      <Card className={classes.resultCard} variant="outlined">
        <Typography variant="h6" className={classes.gradeTitle}>{title}</Typography>
        <Typography variant="h4" className={classes.grade}>
          {score}
          {total
      && `/${total}`}
        </Typography>
      </Card>
    </Grid>
  );
};

GradeCard.propTypes = {
  title: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default GradeCard;
